import React from 'react';
import ObjectToGetParams from '../../helpers/objectToGetParams';
export default function FacebookShare({ text, via, hashtags, children }) {
  const link = `https://twitter.com/share${ObjectToGetParams({
    url:
      typeof window !== 'undefined'
        ? `${window.location.origin}${window.location.pathname}`
        : '',
    text: text && text,
    via: via && via,
    hashtags: hashtags && hashtags.join(','),
  })} `;
  return <React.Fragment>{children({ link })}</React.Fragment>;
}
